import React, { useEffect, useState } from "react";
import Index from "../../../../component/Index";
import { styled } from "@mui/material/styles";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { MobileDatePicker } from "@mui/x-date-pickers/MobileDatePicker";
import dayjs from "dayjs";
import { Controller } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import {
  Autocomplete,
  FormControlLabel,
  MenuItem,
  Radio,
  RadioGroup,
  Select,
} from "@mui/material";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import PropTypes from "prop-types";
import Paper from "@mui/material/Paper";
import moment from "moment";
import Spinner from "../../../../component/Spinner";
import {
  getBankRecoFilterDataApiHandler,
  getBankRecoPrerequisiteData,
  getBankRepoApiHandler,
  updateBankRecoDataApiHandler,
} from "../../../../services/AdminIndex";
import { useDispatch } from "react-redux";
import ContainerIndex from "../../../Index";
import { toast } from "react-toastify";
const Item = styled(Index.Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === "dark" ? "#1A2027" : "#fff",
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: "center",
  color: theme.palette.text.secondary,
}));

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Index.Box sx={{ p: 3 }}>
          <Index.Typography>{children}</Index.Typography>
        </Index.Box>
      )}
    </div>
  );
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};
function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}
const BankRecoReport = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const {
    register,
    handleSubmit,
    control,
    setValue,
    formState: { errors },
    watch,
  } = Index.useForm({
    defaultValues: {
      unclearEntry: true,
    },
  });
  const [currentTab, setCurrentTab] = useState(0);
  const [saveButtonLoader, setSaveButtonLoader] = useState(false);
  const handleChangeTab = (event, newValue) => {
    setCurrentTab(newValue);
  };
  const { loading, token, selectedYearStart, selectedYearEnd } =
    Index.useSelector((state) => {
      return state.ERPAdminReducer;
    });

  const [bankRecoList, setBankRecoList] = useState([]);
  const [errorsDate, setErrorsDate] = useState({});

  const [bankRecoPrerequisiteList, setBankRecoPrerequisiteList] = useState([]);

  const submit = (data) => {
    setSaveButtonLoader(true);
    data.fromDate = moment(new Date(data?.fromDate)).format("YYYY-MM-DD");
    data.toDate = moment(new Date(data?.toDate)).format("YYYY-MM-DD");
    data.bank = data?.bank;
    data.pendingCheque = data?.pendingCheque;
    data.unclearEntry = data?.unclearEntry;

    try {
      getBankRecoFilterDataApiHandler(token, data).then((response) => {
        setSaveButtonLoader(false);
        if (response.status === 201 || response.status === 200) {
          setBankRecoList(response?.data?.data);
        }
      });
    } catch (e) {
      setSaveButtonLoader(false);
    }
  };

  const fetchBankRecoPrerequisiteData = () => {
    dispatch({ type: "LOADER_START" });
    try {
      getBankRecoPrerequisiteData(token).then((response) => {
        dispatch({ type: "LOADER_START" });
        if (response.status == 201 || response.status == 200) {
          dispatch({ type: "LOADER_END" });
          setBankRecoPrerequisiteList(response?.data?.banks);
        } else {
          dispatch({ type: "ADMIN_ERROR_HANDLER", payload: response });
        }
      });
    } catch (e) {
    }
  };

  useEffect(() => {
    // Set today date if selected year is current financial year or set start date of selected year
    const currentDate = dayjs();
    const fyStart = dayjs(selectedYearStart).startOf("day");
    const fyEnd = dayjs(selectedYearEnd).endOf("day");

    const fyStartDate = dayjs(`01-04-${fyStart.year()}`, "DD-MM-YYYY");
    const fyEndDate = dayjs(`31-03-${fyEnd.year()}`, "DD-MM-YYYY");

    let dateToShow = currentDate;

    // If currentDate is NOT within financial year, use start of financial year
    if (!currentDate.isBetween(fyStartDate, fyEndDate, null, '[]')) {
      dateToShow = fyEndDate;
    }

    setValue("fromDate", dayjs(dateToShow));
    setValue("toDate", dayjs(selectedYearEnd));
  }, [selectedYearStart]);
  useEffect(() => {
    fetchBankRecoPrerequisiteData();
  }, []);
  const handleChangeRowData = (index, field, value) => {
    // set item description dynamic
    let updatedList = [...bankRecoList];
    updatedList[index][field] = moment(value?.$d).format("YYYY-MM-DD");
    if (field === "bankRecoDate" && updatedList[index].bankRecoClear === 1) {
      // Clear the date error if the user selects a valid date
      setErrorsDate((prevErrors) => {
        const updatedErrors = { ...prevErrors };
        delete updatedErrors[`dateError${index}`];
        return updatedErrors;
      });
    }

    setBankRecoList(updatedList);
  };

  const submitAll = (data) => {
    setSaveButtonLoader(true);
    const validationErrors = {};
    bankRecoList.forEach((row, index) => {
      if (row.bankRecoClear === 1 && !row.bankRecoDate) {
        validationErrors[`dateError${index}`] =
          "Date is required when 'Yes' is selected.";
      }
      setSaveButtonLoader(false);
    });
    if (Object.keys(validationErrors).length > 0) {
      setErrorsDate(validationErrors);
      return;
    }
    const transformedData = bankRecoList
      .filter((row) => row.bankRecoClear === 1)
      .map((row) => ({
        id: row.id,
        clear: row.bankRecoClear === 1,
        date: row.bankRecoDate
          ? moment(row.bankRecoDate).format("YYYY-MM-DD")
          : null,
      }));

    const formData = { data: transformedData };
    try {
      updateBankRecoDataApiHandler(token, formData).then((response) => {
        setSaveButtonLoader(false);
        toast.success("Bank Reco Updated successfully");
        dispatch({ type: "LOADER_END" });
      });
    } catch (error) {
      setSaveButtonLoader(false);
    }
  };
  return (
    <div>
      <Index.Box className="main_content">
        <Index.Box className="page-title-main">
          <Index.Box className="flex-justify">
            <Index.Typography variant="h4" component="h4">
              Bank Reco Report
            </Index.Typography>
          </Index.Box>
        </Index.Box>
        <Index.Box className="web-main-content">
          <Index.Box className="over-text-scroll">
            <Index.Box className="admin-dashboard-list-row">
              <form className="form-content" onSubmit={handleSubmit(submit)}>
                <Index.Box className="report-main-box report-main-box-set">
                  <Index.Box className="grid-main">
                    <Index.Box
                      display="grid"
                      gridTemplateColumns="repeat(12, 1fr)"
                      className="sales-order-row"
                      gap={{ xs: 2, sm: 2, md: 2, lg: 2 }}
                    >
                      <Index.Box
                        gridColumn={{
                          xs: "span 12",
                          sm: "span 6",
                          md: "span 4",
                          lg: "span 4",
                        }}
                        className="grid-column"
                      >
                        <Item className="grid-item">
                          <Index.Box className="input-box">
                            <Index.Box className="form-group">
                              <Index.FormHelperText className="lable-control">
                                Bank <span className="requried-star">*</span>
                              </Index.FormHelperText>
                              <Index.Box className="dropdown-box auto-drop-box">
                                <Controller
                                  control={control}
                                  {...register("bank", {
                                    required: "Bank is required.",
                                  })}
                                  render={({ field: { onChange, value } }) => (
                                    <Autocomplete
                                      className="custom-form-control"
                                      value={
                                        value
                                          ? bankRecoPrerequisiteList?.find(
                                            (o) => o.id === value
                                          )
                                          : value || null
                                      }
                                      options={bankRecoPrerequisiteList || []}
                                      autoHighlight
                                      onChange={(e, value) => {
                                        onChange(value?.id ? value?.id : "");
                                      }}
                                      getOptionLabel={(option) =>
                                        option?.accountName
                                      }
                                      renderOption={(props, option) => (
                                        <Index.Box
                                          component="li"
                                          sx={{
                                            "& > img": {
                                              mr: 2,
                                              flexShrink: 0,
                                            },
                                          }}
                                          {...props}
                                        >
                                          {option?.accountName}
                                        </Index.Box>
                                      )}
                                      renderInput={(params) => (
                                        <Index.TextField
                                          fullWidth
                                          error={Boolean(errors?.bank)}
                                          className="inner-custom-form-control"
                                          {...params}
                                          size="small"
                                          variant="outlined"
                                        />
                                      )}
                                    />
                                  )}
                                />
                              </Index.Box>
                            </Index.Box>
                          </Index.Box>
                        </Item>
                      </Index.Box>

                      <Index.Box
                        gridColumn={{
                          xs: "span 12",
                          sm: "span 6",
                          md: "span 3",
                          lg: "span 3",
                        }}
                        className="grid-column"
                      >
                        <Item className="grid-item">
                          <Index.Box className="input-box">
                            <Index.Box className="form-group date-of-purchase">
                              <Index.FormHelperText className="lable-control">
                                From Date{" "}
                                <span className="requried-star">*</span>
                              </Index.FormHelperText>

                              <LocalizationProvider dateAdapter={AdapterDayjs}>
                                <DemoContainer components={["DatePicker"]}>
                                  <Controller
                                    control={control}
                                    {...register("fromDate", {
                                      required: "From date is required.",
                                    })}
                                    render={({
                                      field: { onChange, value },
                                    }) => (
                                      <MobileDatePicker
                                        className="custom-form-control"
                                        // disableFuture={true}
                                        minDate={dayjs(selectedYearStart)}
                                        maxDate={dayjs(selectedYearEnd)}
                                        format="DD/MM/YYYY"
                                        value={value}
                                        onChange={(newValue) => {
                                          setValue("fromDate", newValue);
                                        }}
                                        slotProps={{
                                          textField: {
                                            size: "small",
                                            error: Boolean(errors.fromDate),
                                            // error : true
                                          },
                                        }}
                                        error={Boolean(errors.fromDate)}
                                      />
                                    )}
                                  />
                                </DemoContainer>
                              </LocalizationProvider>
                            </Index.Box>
                          </Index.Box>
                        </Item>
                      </Index.Box>
                      <Index.Box
                        gridColumn={{
                          xs: "span 12",
                          sm: "span 6",
                          md: "span 3",
                          lg: "span 3",
                        }}
                        className="grid-column"
                      >
                        <Item className="grid-item">
                          <Index.Box className="input-box">
                            <Index.Box className="form-group date-of-purchase">
                              <Index.FormHelperText className="lable-control">
                                To Date <span className="requried-star">*</span>
                              </Index.FormHelperText>

                              <LocalizationProvider dateAdapter={AdapterDayjs}>
                                <DemoContainer components={["DatePicker"]}>
                                  <Controller
                                    control={control}
                                    {...register("toDate", {
                                      required: "To date is required.",
                                    })}
                                    render={({
                                      field: { onChange, value },
                                    }) => (
                                      <MobileDatePicker
                                        className="custom-form-control"
                                        // disableFuture={true}
                                        minDate={
                                          watch("fromDate")
                                            ? dayjs(watch("fromDate"))
                                            : dayjs(selectedYearStart)
                                        }
                                        maxDate={dayjs(selectedYearEnd)}
                                        format="DD/MM/YYYY"
                                        value={value}
                                        onChange={(newValue) => {
                                          setValue("toDate", newValue);
                                        }}
                                        slotProps={{
                                          textField: {
                                            size: "small",
                                            error: Boolean(errors.toDate),
                                            // error : true
                                          },
                                        }}
                                        error={Boolean(errors.toDate)}
                                      />
                                    )}
                                  />
                                </DemoContainer>
                              </LocalizationProvider>
                            </Index.Box>
                          </Index.Box>
                        </Item>
                      </Index.Box>
                      <Index.Box
                        gridColumn={{
                          xs: "span 12",
                          sm: "span 12",
                          md: "span 12",
                          lg: "span 12",
                        }}
                        className="grid-column"
                      >
                        <Item className="grid-item">
                          <Index.Box className="input-box">
                            <Index.Box className="form-group">
                              <Index.FormHelperText className="lable-control">
                                Only Uncleared Entries{" "}
                                <span className="requried-star">*</span>
                              </Index.FormHelperText>
                              <RadioGroup
                                row
                                aria-labelledby="demo-row-radio-buttons-group-label"
                                name="row-radio-buttons-group"
                                className="radio-group"
                                value={watch("unclearEntry")} // Binding the radio button value
                                onChange={(e, value) => {
                                  setValue("unclearEntry", value === "yes"); // Setting the selected value
                                }}
                              >
                                <FormControlLabel
                                  value="yes"
                                  checked={watch("unclearEntry") === true}
                                  control={<Radio />}
                                  label="Yes"
                                  className="radio-control"
                                />
                                <FormControlLabel
                                  value="no"
                                  checked={watch("unclearEntry") === false}
                                  control={<Radio />}
                                  label="No"
                                  className="radio-control"
                                />
                              </RadioGroup>
                            </Index.Box>
                          </Index.Box>
                        </Item>
                      </Index.Box>

                      <Index.Box
                        gridColumn={{
                          xs: "span 12",
                          sm: "span 12",
                          md: "span 12",
                          lg: "span 12",
                        }}
                        className="grid-column"
                      >
                        <Item className="grid-item">
                          <Index.Box className="input-box">
                            <Index.Box className="form-group">
                              <Index.Box className="checkbox-content-flex">
                                <Index.FormHelperText
                                  className="checkbox-lable"
                                // disabled={watch("billWise")}
                                >
                                  Pending cheques of Last Year
                                </Index.FormHelperText>
                                <Index.Box className="checkbox-main">
                                  <Controller
                                    control={control}
                                    {...register("pendingCheque")}
                                    render={({
                                      field: { onChange, value },
                                    }) => (
                                      <input
                                        // disabled={watch("billWise")}
                                        type="checkbox"
                                        className="checkbox"
                                        checked={value}
                                        onChange={() =>
                                          setValue(
                                            "pendingCheque",
                                            !watch("pendingCheque")
                                          )
                                        }
                                      />
                                    )}
                                  />
                                </Index.Box>
                              </Index.Box>
                            </Index.Box>
                          </Index.Box>
                        </Item>
                      </Index.Box>
                    </Index.Box>
                  </Index.Box>
                  <Index.Box className="btn-flex-end custom-flex-btn">
                    <Index.Box></Index.Box>
                    <Index.Box className="flex-btn-custom">
                      <Index.Box className="secondary-btn-main">
                        <Index.Button
                          variant=""
                          className="secondary-button"
                          onClick={() => navigate(-1)}
                          disabled={saveButtonLoader}
                        >
                          Close
                        </Index.Button>
                      </Index.Box>
                      <Index.Box className="btn-primary-main">
                        <Index.Button
                          variant=""
                          className="btn-primary"
                          disabled={saveButtonLoader}
                          type="submit"
                        >
                          {/* Show list */}
                          {saveButtonLoader ? <Spinner /> : "Show list"}
                        </Index.Button>
                      </Index.Box>
                    </Index.Box>
                  </Index.Box>
                </Index.Box>
              </form>
              {bankRecoList?.length ? (
                <Index.Box className="common-card m-30">
                  <Index.Box className="page-table-main genrate-otherssalesentry-scrollbale-table-main">
                    <TableContainer
                      component={Paper}
                      className="table-container scrollable-table-container"
                      sx={{ maxHeight: 255 }}
                    >
                      <Table
                        className="table"
                        stickyHeader
                        aria-label="sticky summary-table table"
                      >
                        <TableHead className="table-head">
                          <TableRow className="table-row">
                            <TableCell
                              component="th"
                              scope="row"
                              className="table-th"
                              colSpan={"100%"}
                            >
                              <Index.Typography className="table-data-text">
                                Funky Apperal
                              </Index.Typography>
                            </TableCell>
                          </TableRow>
                          <TableRow className="table-row">
                            <TableCell
                              component="th"
                              scope="row"
                              className="table-th"
                              colSpan={"100%"}
                            >
                              <Index.Typography className="table-data-text">
                                Bank Reconcilation Report
                              </Index.Typography>
                            </TableCell>
                          </TableRow>
                          <TableRow className="table-row">
                            <TableCell
                              component="th"
                              scope="row"
                              className="table-th"
                              colSpan={"100%"}
                            >
                              <Index.Typography className="table-data-text">
                                Bank Statement of{" "}
                                {
                                  bankRecoPrerequisiteList?.find(
                                    (o) => o.id === watch("bank")
                                  ).accountName
                                }
                              </Index.Typography>
                            </TableCell>
                          </TableRow>
                          <TableRow className="table-row">
                            <TableCell
                              component="th"
                              scope="row"
                              className="table-th"
                              colSpan={"100%"}
                            >
                              <Index.Typography className="table-data-text">
                                From{" "}
                                {moment(new Date(watch("fromDate"))).format(
                                  "DD/MM/YYYY"
                                )}{" "}
                                To{" "}
                                {moment(new Date(watch("toDate"))).format(
                                  "DD/MM/YYYY"
                                )}
                              </Index.Typography>
                            </TableCell>
                          </TableRow>
                          <TableRow className="table-row">
                            <TableCell
                              component="th"
                              scope="row"
                              className="table-th"
                            >
                              <Index.Typography className="table-data-text">
                                Balance as per Bank Book
                              </Index.Typography>
                            </TableCell>
                            <TableCell
                              component="th"
                              scope="row"
                              className="table-th"
                            ></TableCell>
                            <TableCell
                              component="th"
                              scope="row"
                              className="table-th"
                            ></TableCell>
                            <TableCell
                              component="th"
                              scope="row"
                              className="table-th"
                            ></TableCell>
                            <TableCell
                              component="th"
                              scope="row"
                              className="table-th"
                            ></TableCell>
                            <TableCell
                              component="th"
                              scope="row"
                              className="table-th"
                            >
                              <Index.Typography className="table-data-text">
                                38261.04
                              </Index.Typography>
                            </TableCell>
                          </TableRow>
                          <TableRow className="table-row">
                            <TableCell
                              component="th"
                              scope="row"
                              className="table-th"
                              colSpan={"100%"}
                            >
                              <Index.Typography className="table-data-text">
                                {" "}
                              </Index.Typography>
                            </TableCell>
                          </TableRow>
                          <TableRow className="table-row">
                            <TableCell
                              component="th"
                              scope="row"
                              className="table-th"
                              colSpan={"100%"}
                            >
                              <Index.Typography className="table-data-text">
                                Add : Cheque(s) issued but not cleared
                              </Index.Typography>
                            </TableCell>
                          </TableRow>
                          <TableRow className="table-row">
                            <TableCell
                              component="th"
                              scope="row"
                              className="table-th"
                              colSpan={"100%"}
                            >
                              <Index.Typography className="table-data-text">
                                {" "}
                              </Index.Typography>
                            </TableCell>
                          </TableRow>
                          <TableRow>
                            <TableCell
                              component="th"
                              scope="row"
                              className="table-th"
                            >
                              Date
                            </TableCell>

                            <TableCell
                              component="th"
                              scope="row"
                              className="table-th"
                            >
                              Account Name
                            </TableCell>
                            <TableCell
                              component="th"
                              scope="row"
                              className="table-th"
                            >
                              Voucher No.
                            </TableCell>
                            <TableCell
                              component="th"
                              scope="row"
                              className="table-th"
                            >
                              Chq. No.
                            </TableCell>
                            <TableCell
                              component="th"
                              scope="row"
                              className="table-th"
                            >
                              Amount
                            </TableCell>
                            <TableCell
                              component="th"
                              scope="row"
                              className="table-th"
                            ></TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody className="table-body">
                          {bankRecoList?.map((row, index) => (
                            <TableRow key={row?.id} className="table-row">
                              <TableCell
                                component="td"
                                scope="row"
                                className="table-td"
                              >
                                01/04/2024
                              </TableCell>
                              <TableCell
                                component="td"
                                scope="row"
                                className="table-td"
                              >
                                OTHER CHARGES
                              </TableCell>
                              <TableCell
                                component="td"
                                scope="row"
                                className="table-td"
                              >
                                BP08/00109
                              </TableCell>

                              <TableCell
                                component="td"
                                scope="row"
                                className="table-td"
                              >
                                NEFT
                              </TableCell>

                              <TableCell
                                component="td"
                                scope="row"
                                className="table-td"
                              >
                                10000.00
                              </TableCell>
                              <TableCell
                                component="td"
                                scope="row"
                                className="table-td"
                              >
                                {bankRecoList.length - 1 === index
                                  ? "629960.96"
                                  : ""}
                              </TableCell>
                            </TableRow>
                          ))}
                          <TableRow className="table-row">
                            <TableCell
                              component="td"
                              scope="row"
                              className="table-td"
                            ></TableCell>
                            <TableCell
                              component="td"
                              scope="row"
                              className="table-td"
                            ></TableCell>
                            <TableCell
                              component="td"
                              scope="row"
                              className="table-td"
                            ></TableCell>

                            <TableCell
                              component="td"
                              scope="row"
                              className="table-td"
                            ></TableCell>

                            <TableCell
                              component="td"
                              scope="row"
                              className="table-td"
                            ></TableCell>
                            <TableCell
                              component="td"
                              scope="row"
                              className="table-td"
                            >
                              668222.00
                            </TableCell>
                          </TableRow>
                        </TableBody>
                      </Table>
                    </TableContainer>
                  </Index.Box>
                </Index.Box>
              ) : (
                <></>
              )}
            </Index.Box>
          </Index.Box>
        </Index.Box>
      </Index.Box>
    </div>
  );
};

export default BankRecoReport;
